'use strict';

angular.module('user')
    .component('signupPending', {
        templateUrl: 'js/modules/user/components/signup-pending/template.html',
        controller: 'ApiAuthSignupPendingController',
        controllerAs: 'SignUpController',
        bindings: {
            user: '<',
        },
    });
